import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import LoginService from '@/account/login.service';
import RegisterService from './register.service';
import { EMAIL_ALREADY_USED_TYPE, ORGANIZATION_ALREADY_USED_TYPE } from '@/constants';
import CountryList from '@/shared/static/country-list';
import {StateList} from '@/shared/static/state-list';
import RegionService from '@/entities/region/region.service';
import { IRegion } from '@/shared/model/region.model';
import ValidationMixin from '@/shared/data/validation-mixin';
import OrganizationService from '@/entities/organization/organization.service';
import { IOrganization } from '@/shared/model/organization.model';
import LearnerStratergy  from '@/account/upgrade/learner/checkout/learner.stratergy.vue';
import LearnerUpdatePlan  from '@/account/upgrade/learner/update/learner-update.vue';
import AccountService from '../account.service';
import { utils } from '@/shared/utils';

@Component({
  mixins: [ValidationMixin],
  components: {
    LearnerStratergy,
    LearnerUpdatePlan
  }
})
export default class Register extends Vue {
  @Inject('registerService') private registerService: () => RegisterService;
  @Inject('loginService') private loginService: () => LoginService;
  @Inject('regionService') private regionService: () => RegionService;
  @Inject('organizationService') private organizationService: () => OrganizationService;
  @Inject('accountService') private accountService: () => AccountService;

  public registerBuy: any = {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    organizationName: undefined,
    planNickname: undefined,
    region: undefined,
    coupon: undefined
  };
  public error = '';
  public errorEmailExists = '';
  public errorOrgExists = '';
  public success = false;
  public currentLanguage = '';
  public countryList = [];
  public stateList = [];
  public planDescription = null;
  public appsIncluded = '';
  public showEstimate = false;
  public subscriptionSuccess = false;
  public step = 'Register';
  public regions: IRegion[] = [];
  public resellerId = null;
  public reseller: IOrganization = null;
  public loading = false;
  public buyStep = 1;
  public updateCheckout = false;
  public userHasSubscription = null;
  public elbSubscription = null;
  public ecomSubscription = null;
  public planToAdd = null;
  public user = null;
  public couponCode = null;
  public organization: IOrganization = null;

  created(): void {
    this.currentLanguage = this.$store.getters.currentLanguage;
    this.$store.watch(
      () => this.$store.getters.currentLanguage,
      () => {
        this.currentLanguage = this.$store.getters.currentLanguage;
      }
    );


    this.registerBuy.planNickname = 'elb_gold_suite';

    if (this.$route.query.plan) {
      this.registerBuy.planNickname = this.$route.query.plan;
    }

    if (this.$route.query.code) {
      this.couponCode = this.$route.query.code;
    }


    this.countryList =  CountryList;
    this.stateList = StateList;

    this.getRegions();

    if (this.accountService().authenticated) {
      this.showEstimate = true;
      this.buyStep = 2;

      this.retriveOrganization(this.accountService().getUserOrganizationId());

    }
  }

  public updateSteps() {
    const subscriptions = this.organization.subscriptions;
    this.elbSubscription = this.isTrialing(subscriptions);
    if (this.elbSubscription) {
      this.registerBuy.enterpriseToStripe = true;
    } else {
      this.userHasSubscription  = this.hasSubscription(subscriptions);
      if (this.userHasSubscription) {
        this.buyStep = 3;
        this.showEstimate = false;
      }
    }

    if (this.hasEcomSubscription(subscriptions)) {
      this.planToAdd = this.registerBuy.planNickname;
      this.registerBuy.planNickname = this.ecomSubscription.plan.nickname;
      this.updateCheckout = true;
    }
  }

  public retriveOrganization(organizationId) {
    this.organizationService()
    .find(organizationId)
    .then((res) => {
      this.organization = res;
      this.updateSteps();
    });
  }

  public get userAccount() {
    if (this.updateCheckout) {
      return null;
    }
    return this.user ? this.user : this.$store.getters.account;
  }

  public get userSubscriptions() {
    return  this.accountService().getSubscriptions();
  }

  public hasEcomSubscription(subscriptions): boolean {
    for (const sub of subscriptions) {
      if (sub.stripeId) {
        this.ecomSubscription = sub;
        return true;
      }
    }
    return false;
  }

  public isTrialing(subscriptions): any {
    const cleanNickname = utils.removeAfterLastUnderscore(this.registerBuy.planNickname);
    for (const sub of subscriptions) {
      if (sub.plan.nickname.includes('trial') && utils.removeAfterLastUnderscore(sub.plan.nickname) === cleanNickname) {
        return sub;
      }
    }

    return null;
  }

  public hasSubscription(subscriptions): any {
    const cleanNickname = utils.removeAfterLastUnderscore(this.registerBuy.planNickname);
    for (const sub of subscriptions) {
      const cleanSubNickname = utils.removeAfterLastUnderscore(sub.plan.nickname);
      if (cleanSubNickname === cleanNickname) {
        return sub;
      }
    }
    return null;
  }

  public gotoSubscription() {
    if (this.userHasSubscription) {
      this.$router.push({
        name: 'ElbSubscriptionView',
        params: { id: this.userHasSubscription.id },
      });
    }
  }

  public accountCreated() {
    this.success = true;
  }

  public countryChanged() {
    this.stateList = StateList;
  }

  public onDoneCheckout() {
    this.subscriptionSuccess = true;
    this.showEstimate = false;
    if (this.accountService().authenticated) {
      if (this.accountService().isAuthor() || this.accountService().isOrgAdmin()) {
        this.$router.push({
          name: 'ProductVersionApps',
        });
      } else {
        this.$router.push({
          name: 'ApplicationUser',
        });
      }
    } else {
      this.accountCreated();
    }
    localStorage.removeItem('planToAdd');
  }

  public onCancelCheckout() {
    this.showEstimate = false;
  }

  public continentToRegion(continent: string) {
    let region = null;
    if (this.regions && this.regions.length === 0) {
      return region;
    }

    this.regions.forEach((ele) => {
      if (ele.name === 'United States') {
        region = ele.name;
      }
    });

    if (region == null) {
      return null;
    }

    switch (continent) {
      case 'North America':
      case 'South America': region = this.getRegionKey('United States'); break;
      case 'Asia':
      case 'Australia': region = this.getRegionKey('Australia'); break;
      case 'Africa':
      case 'Europe': region = this.getRegionKey('Europe'); break;
      default: region = this.getRegionKey('United States'); break;
    }

    return region;
  }

  public getRegionKey(displayName) {
    let key = null;
    this.regions.forEach((ele) => {
      if (ele.name === displayName) {
        key = ele.key;
      }
    });

    return key;
  }

  public toLogin() {
    localStorage.setItem('requested-url', this.$route.fullPath);
    this.openLogin();
  }

  public getRegions() {
    const pvPaginationQuery = {
      page: 0,
      size: 50,
      sort: ['id,asc']
    };

    this.regionService()
    .retrieve(pvPaginationQuery)
    .then((res) => {
      this.regions = res.data;

    });
  }


  public register() {
    this.error = null;
    this.errorOrgExists = null;
    this.errorEmailExists = null;
    this.registerBuy.langKey = 'en';
    if (this.registerBuy.planNickname == null) {
      this.registerBuy.planNickname = 'elb_gold_suite';
    }

    this.cleanData();

    if (this.reseller) {
      this.registerBuy.region = this.reseller.instanceName;
    }
    this.loading = true;
    this.$recaptcha('register').then((token) => {
      this.registerService()
        .processRegistrationBuy(this.registerBuy, token)
        .then((resp) => {
          this.user = resp;
          if (this.needsPayment()) {
            localStorage.setItem('planToAdd', this.registerBuy.planNickname);
            this.showEstimate = true;
            this.buyStep = 2;
          } else {
            this.success = true;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.success = null;
          this.loading = false;
          if (error.response.status === 400 && error.response.data.type === ORGANIZATION_ALREADY_USED_TYPE) {
            this.errorOrgExists = 'ERROR';
          } else if (error.response.status === 400 && error.response.data.type === EMAIL_ALREADY_USED_TYPE) {
            this.errorEmailExists = 'ERROR';
          } else {
            this.error = 'ERROR';
          }
        });
    }).catch((err) => {
      this.loading = false;
      console.log(err);
    });

  }

  public cleanData() {
    const blockSpecialRegex = /[~`!@#$%^&()_={}[\]:;,.<>+\/?-]/g;
    this.registerBuy.firstName = this.registerBuy.firstName.replace(blockSpecialRegex, '');
    this.registerBuy.lastName = this.registerBuy.lastName.replace(blockSpecialRegex, '');
    this.registerBuy.organizationName = this.registerBuy.organizationName.replace(blockSpecialRegex, '');
    // this.registerBuy.phoneNumber = this.registerAccount.phoneNumber.replace(blockSpecialRegex, '');

  }

  public needsPayment() {
    return !this.registerBuy.planNickname.includes('trial');
  }

  public openLogin(): void {
    this.$router.push({
      name: 'Signin'
    });
  }

  public openPricing(): void {
    this.$router.push({
      name: 'AccountPlan'
    });
  }

  public blockChars(e) {
    const blockSpecialRegex = /[~`{}[\]:;<>\/]/;
    const key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (blockSpecialRegex.test(key)) {
      e.preventDefault();
      return false;
    }
  }
}
